import React from 'react'
import PropTypes from 'prop-types'

import Divider from 'material-ui/Divider'

import EstimateHeader from './modules/header/EstimateHeader'
import BillItems from 'billing/common/modules/items/BillItems'
import BillNotes from 'billing/common/modules/notes/BillNotes'

const SectionSeparator = () =>
  <div style={styles.separator}>
    <Divider />
  </div>

export default class EstimateContent extends React.Component {

  static propTypes = {
    estimateEditor: PropTypes.object.isRequired,
    estimateVersion: PropTypes.number.isRequired,
    onHamburgerClicked: PropTypes.func.isRequired
  }

  render() {
    const sections = []
    sections.push(
      <EstimateHeader
        key='header'
        estimateVersion={this.props.estimateVersion}
        estimateEditor={this.props.estimateEditor} />)
    sections.push(<SectionSeparator key='s0' />)
    sections.push(
      <BillItems key='items' billEditor={this.props.estimateEditor} billingEntity='estimate' />)
    sections.push(<SectionSeparator key='s1' />)
    sections.push(
      <BillNotes key='notes' billEditor={this.props.estimateEditor} />)
    return (
      <div style={styles.screen}>
        <div style={styles.container}>
          { sections }
        </div>
      </div>
    )
  }

}

const styles = {
  screen: {
    display: 'flex',
    flexDirection: 'column'
  },
  container: {
    marginLeft: 64,
    marginRight: 64,
    marginTop: 24,
    overflow: 'auto'
  },
  separator: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f1f1f1',
    marginTop: 32,
    marginBottom: 32
  },
  hamburger: {
    marginTop: 12,
    marginLeft: 12,
    cursor: 'pointer'
  }
}



// WEBPACK FOOTER //
// ./src/billing/estimates/EstimateContent.js